import React, { ReactNode } from 'react';
import Div from '../Div';
import Modal from './Modal';
import CrossIcon from '@/components/Icons/Cross';

// Define the props interface
interface DrawerProps {
  modalOpen: boolean;
  onClose?: any;
  children: ReactNode;
  showCloseButton?: boolean;
  closeIcon?: any;
  showHeader?: boolean;
  className?: any;
  width?: any;
}

function Drawer({
  modalOpen,
  onClose = () => {},
  showCloseButton = true,
  children,
  closeIcon,
  showHeader = false,
  className,
  width,
}: DrawerProps) {
  return modalOpen ? (
    <Modal
      id="navbar-modal"
      open={modalOpen}
      showCloseButton={showCloseButton}
      showHeader={showHeader}
      onClose={() => onClose()}
      closeIcon={closeIcon}
      classNames={`bg-white py-6 md:px-s6 md:py-s7 !mt-0 border-0 rounded-xl rounded-bl-none rounded-br-none ${className}`}
      width={`md:!fixed md:!top-0 md:!bottom-0 md:!right-0 md:!w-[33vw] md:!h-screen md:rounded-none md:!max-h-full ${width}`}
    >
      {children}
    </Modal>
  ) : null;
}

export default React.memo(Drawer);
